import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ErrorResponse } from '../api/hscan';
import {
  requestExplicitConsent,
  grantExplicitConsent,
  ExplicitConsent,
} from '../api/hscan/explicitConsent';

import { MutationOption, QueryOption } from './react-query-type';

export const useExplicitConsent = (
  { uuid }: { uuid: string },
  options?: QueryOption<
    ExplicitConsent,
    ExplicitConsent,
    AxiosError<ErrorResponse>
  >,
) => {
  return useQuery({
    queryKey: ['EXPLICIT_CONSENT', uuid],
    queryFn: async () => {
      const { data } = await requestExplicitConsent(uuid);
      return data;
    },
    ...options,
  });
};

export const useGrantExplicitConsent = (
  { uuid }: { uuid: string },
  options?: MutationOption<unknown, unknown>,
) => {
  return useMutation({
    mutationFn: async () => {
      await grantExplicitConsent(uuid);
    },
    ...options,
  });
};
